module.exports = __webpack_public_path__ + "img/import-grey.ce8a8d0f.svg";